import type SwiperClass from 'swiper/types/swiper-class';
import { component } from 'picoapp';

export default component(async (node) => {
  const sliderElement: HTMLElement = node.querySelector('[data-slider]');

  interface TopbarConfig {
    autoplaySpeed: number
  }

  const config: TopbarConfig = JSON.parse(node.dataset.config);
  const { autoplaySpeed } = config;

  const initSlider = async () => {
    const { default: Swiper, Autoplay } = (await import(
      /* webpackChunkName: "swiper" */
      'modules/swiper'
    ));

    let slider: SwiperClass;

    const createSlider = () => {
      slider = new Swiper(sliderElement, {
        modules: [Autoplay],
        slidesPerView: 1,
        loop: true,
        speed: 400,
        autoplay: {
          delay: autoplaySpeed,
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            loop: false,
          },
        },
      });
    };

    const destroySlider = () => {
      slider.destroy();
    };

    if (window.innerWidth < 1024) {
      createSlider();
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth < 1024 && (slider === undefined || slider.destroyed)) {
        createSlider();
      }

      if (window.innerWidth >= 1024 && (slider !== undefined && !slider.destroyed)) {
        destroySlider();
      }
    });
  };

  const init = () => {
    initSlider();
  };

  init();
});
